import React from 'react'
import s from './meterVerif.module.css'
import { HiOutlineChevronRight } from "react-icons/hi2";

function MeterVerif() {

  return (
    <div className={s.meterVerif}> 
        <div className={s.container} >
        <div className={s.blockTree}>
              <span className={s.item} >Услуги</span>
              <HiOutlineChevronRight />
               <span className={s.item}>Дистанционный съем показаний</span>
            </div>
            
            <h2>
              <span className={s.text}>Дистанционный съем показаний</span> 
              <span className={s.text}>показаний счетчиков воды и тепла {" "} </span> 
            </h2>
      </div>
      
       
</div>
  )
}


export default MeterVerif